import { useEffect, useRef } from 'react';
import { api, getToken } from '../api.js';

// Debounced autosave of the answer store to PATCH /api/ntq. Best-effort: errors are
// swallowed (the local session still holds the answers) and it no-ops until there's a
// session token. The server merges partials, so sending the whole map is safe.
export function useAutosave(answers, { delay = 800, progress } = {}) {
  const saving = useRef(false);
  useEffect(() => {
    if (!getToken() || !answers || Object.keys(answers).length === 0) return undefined;
    const id = setTimeout(async () => {
      if (saving.current) return;
      saving.current = true;
      try {
        // Send the app's progress % so the server can sync ntq_percentage to HubSpot.
        await api.patch('/ntq', { answers, assessment_progress: progress });
      } catch {
        /* offline / not-yet-deployed — keep local state */
      } finally {
        saving.current = false;
      }
    }, delay);
    return () => clearTimeout(id);
  }, [answers, delay]);
}
